import { useCallback } from "react";
import "./Condition.css";
import { useState } from "react";

const Condition = (props) => {
  const [data, setData] = useState(props.getData());
  const [selectedText, setSelectedText] = useState("");
  const [searchText, setSearchText] = useState("");

  const handleChange = useCallback(
    (e) => {
      setSearchText(e.target.value);
      setSelectedText("");
      const originalData = props.getData();
      const filteredData = originalData.objects.filter((item) =>
        item.resource.code.text
          .trim()
          .toLowerCase()
          .includes(e.target.value.trim().toLowerCase())
      );
      setData({ objects: filteredData });
    },
    [props]
  );

  return (
    <div className="observationContainerResource">
      <div className="search">
        <input
          type="text"
          value={searchText}
          onChange={handleChange}
          className="searchBox"
          placeholder="Search..."
        />
      </div>
      {data?.objects?.map((item, index) => (
        <div
          key={index}
          className={`${index === data?.objects?.length - 1 ? "lastRow" : ""} ${
            selectedText === index ? "active" : ""
          } cursor-pointer observationItem`}
          onClick={() => {
            props.setResourceListData(item);
            setSelectedText(index);
          }}
        >
          {item?.resource?.code?.text} - {item?.resource?.category[0]?.text}
        </div>
      ))}
    </div>
  );
};

export default Condition;
